import React from 'react';
import PropTypes from 'prop-types';
import styles from './Toggle.module.scss';

const Toggle = ({ checked, onChange, label, disabled, labelPosition = 'left' }) => {
  const labelEl = label && <span className={styles.label}>{label}</span>;
  return (
    <div className={styles.wrapper}>
      {labelPosition === 'left' && labelEl}
      <button
        type="button"
        className={`${styles.toggle} ${checked ? styles.toggleOn : ''} ${disabled ? styles.toggleDisabled : ''}`}
        onClick={onChange}
        disabled={disabled}
      >
        <span className={styles.thumb} />
      </button>
      {labelPosition === 'right' && labelEl}
    </div>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['left', 'right']),
};

export default Toggle;
